import { ReportItem } from '@cims-online/shared'
import { createStrictContext } from 'utils/createContext'
import { useEffect, useState } from 'react'
import { LabeledValueType } from 'components/CIMSSelect/types'
import { useReportRecordSelectContext } from 'components/CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'
import { SingleReportsContext } from './types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<SingleReportsContext>(
  'SingleReportsContext'
)

export const useSingleReportsContext = useContextFn

const SingleReportsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const [report, setReport] = useState<ReportItem | undefined>(undefined)
  const [value, setValue] = useState<LabeledValueType | undefined>()
  const [globalId, setGlobalId] = useState<string | undefined>()

  const { fromLabeledValue } = useReportRecordSelectContext()
  useEffect(() => {
    setValue(undefined)
  }, [projectId, report])
  useEffect(() => {
    const from = fromLabeledValue(value)
    if (!from) return setGlobalId(undefined)
    return setGlobalId(from.reportId)
  }, [fromLabeledValue, value])
  return (
    <Provider
      value={{
        report,
        setReport,
        globalId,
        value,
        setValue,
      }}
    >
      {children}
    </Provider>
  )
}

export default SingleReportsProvider
